import { createContext, useContext } from 'react';
import { defaultTheme } from './theme.default';
import type { DbThemeConfig } from './theme.types';

/**
 * 主题 Context
 * 默认值为 defaultTheme，即使不包裹 Provider 也能正常使用
 */
export const DbThemeContext = createContext<DbThemeConfig>(defaultTheme);

/**
 * 获取当前主题
 *
 * @example
 * const theme = useDbTheme();
 * const color = props.titleColor ?? theme.colors.text;
 */
export const useDbTheme = (): DbThemeConfig => {
    return useContext(DbThemeContext);
};